var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.82.993a.83.83 0 0 1 1.197-.04L3.684 2.62c.133.133.13.35-.005.486l-.346.346-.346.347a.344.344 0 0 1-.486.005L.87 2.174C.554 1.857.51 1.329.819.993zM7.212.897a.828.828 0 0 1 1.17-.013c.161.16.24.371.237.583a.844.844 0 0 1-.249.588L5.747 4.682l2.531 2.532c.316.316.36.844.051 1.181a.83.83 0 0 1-1.197.04L4.563 5.867 1.948 8.485a.829.829 0 0 1-1.171.012.81.81 0 0 1-.236-.583.844.844 0 0 1 .249-.588L7.213.896z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c93f97f1.svg";
export { ForwardRef as ReactComponent };